module.exports = __webpack_public_path__ + "assets/img/faspay_402.992cc364.png";